import { render } from "./GoodsDetailHeader.vue?vue&type=template&id=2f5e117d"
import script from "./GoodsDetailHeader.vue?vue&type=script&lang=js"
export * from "./GoodsDetailHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__